// Directory navigation data — pure data, no JSX.
//
// Each top-level entry is a folder with a stable `key`, a display `label`, and
// a list of `children` (leaves). Each leaf has its own `key`, `label`, and a
// `placeholderBody` string rendered into the [FIG. 2] content frame on select.
//
// Child counts are intentionally mixed (Products 3, Services 3, About 1,
// Contact 1) per the plan — richer for the navigable areas, terminal-style
// brevity for the static ones. Real content lands in future Ideas; swapping a
// `placeholderBody` here requires no component changes.

const directoryData = [
  {
    key: 'products',
    label: 'Products',
    children: [
      {
        key: 'products/signal',
        label: 'signal',
        placeholderBody:
          'Signal is an experiment in ambient observability — surfacing the few metrics that matter without the dashboard sprawl.',
      },
      {
        key: 'products/relay',
        label: 'relay',
        placeholderBody:
          'Relay routes events between your tools so the right context lands in the right place at the right time.',
      },
      {
        key: 'products/forge',
        label: 'forge',
        placeholderBody:
          'Forge turns rough prompts into shippable workflows — a workbench for building with agents.',
      },
    ],
  },
  {
    key: 'services',
    label: 'Services',
    children: [
      {
        key: 'services/advisory',
        label: 'advisory',
        placeholderBody:
          'Short, focused engagements to pressure-test an idea and chart the fastest path to a working prototype.',
      },
      {
        key: 'services/build',
        label: 'build',
        placeholderBody:
          'Hands-on builds where we embed with your team and ship the first version alongside you.',
      },
      {
        key: 'services/operate',
        label: 'operate',
        placeholderBody:
          'Ongoing support for the systems we build together — monitoring, iteration, and steady improvement.',
      },
    ],
  },
  {
    key: 'about',
    label: 'About',
    children: [
      {
        key: 'about/lab',
        label: 'the lab',
        placeholderBody:
          'Aronis Labs is a small studio experimenting at the edge of agents, tooling, and developer experience.',
      },
    ],
  },
  {
    key: 'contact',
    label: 'Contact',
    children: [
      {
        key: 'contact/say-hello',
        label: 'say hello',
        placeholderBody:
          'Got an idea worth prototyping? Reach out — we read every message and reply to the interesting ones.',
      },
    ],
  },
];

export default directoryData;
